import { render, staticRenderFns } from "./BrandCatalogue.vue?vue&type=template&id=3ee7b3f8&scoped=true"
import script from "./BrandCatalogue.vue?vue&type=script&lang=js"
export * from "./BrandCatalogue.vue?vue&type=script&lang=js"
import style0 from "./BrandCatalogue.vue?vue&type=style&index=0&id=3ee7b3f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee7b3f8",
  null
  
)

export default component.exports